/* eslint-disable prettier/prettier */
export const colors = {
	orange: '#10A4D2',
	blue: '#FD502E',
	green: '#2fb786',
	errorColor: '#FE512F',
	primary: '#001DF5',
	primaryDark: '#0C679B',
	primaryLight: '#CFE8F6',
	primaryGradient: 'linear-gradient(56.4deg, #0C679B 8.08%, #108CD2 87.11%)',
	primaryLightGradient:
		'linear-gradient(180deg, rgba(207, 232, 246, 0) 0%, #CFE8F6 100%)',
	primaryLighterGradient: 'linear-gradient(180deg, #FFFFFF 0%, #E9FAFF 100%)',
	secondary: '#B4E4DC',
	secondaryDark: '#FE512F',
	secondaryGradient: 'linear-gradient(56.4deg, #FE512F 8.08%, #FF7B02 87.11%)',
	dark: '#051B1E',
	textDark: '#37494b',
	lighterDark: '#4D525B',
	white: '#FFFFFF',
	borderLight: '#D6DDEB',
	gradientOne: 'linear-gradient(56.4deg, #0C679B 8.08%, #FD502E 87.11%)',
	gradientTwo: 'linear-gradient(56.4deg, #10A4D2 8.08%, #FD502E 87.11%)',
	gradientThree: 'linear-gradient(56.4deg, #0C679B 8.08%, #FF7B02 87.11%)',
	inputBackground: '#FAFAFA',
	black: '#000',
	sky: '#ecf9ef',
	warmGray: '#efeff2',
};
